import { createListenerMiddleware } from '@reduxjs/toolkit';

import { searchRooms } from './actions';
import { setRoomsSearchIsLoading } from './roomsSearchSlice';

import type { RootState } from 'store';

export const roomsSearchListener = createListenerMiddleware<RootState>();

roomsSearchListener.startListening({
  actionCreator: searchRooms.pending,
  effect: (_args, { dispatch }) => {
    dispatch(setRoomsSearchIsLoading(true));
  },
});
